import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

interface ProtectedRouteProps {
  redirectPath?: string;
}

/**
 * A wrapper component that checks if the user is authenticated.
 * If authenticated, renders the children.
 * If not authenticated, redirects to the login page.
 */
const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ 
  redirectPath = '/login'
}) => {
  const { currentUser, loading } = useAuth();
  const location = useLocation();

  // While authentication state is loading, show a loading indicator
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-indigo-500"></div>
      </div>
    );
  }
  
  // If not authenticated, redirect to login with the return path
  if (!currentUser) {
    // Save the attempted URL for redirecting after login
    return <Navigate to={redirectPath} state={{ from: location }} replace />;
  }

  // If the user is authenticated, render the outlet
  return <Outlet />;
};

export default ProtectedRoute; 